import { Rating } from '@/types';
import { useRef } from 'react';

import styles from './ProductRatingTag.module.scss';

type ProductRatingTagProps = {
  rating: Rating
}

const ProductRatingTag = ({ rating }: ProductRatingTagProps) => {
  return (
    <div className={styles.tag}>
      {rating.name} | <span className={styles.value} data-test-id="value">{rating.value}</span>
    </div>
  );
};

export default ProductRatingTag;
